export default __webpack_public_path__ + "static/media/ferdinand.de2b368d.webp";